import React, { useEffect } from 'react';

function VaterstettenWidgetPage() {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = '/widget.js';
    script.async = true;

    script.setAttribute('data-city', 'Gemeinde Vaterstetten');
    script.setAttribute('data-locale', 'de');

    const widgetId =
      process.env.REACT_APP_DEFAULT_WIDGET_ID || '80771963-3e70-4317-b098-992545c22c9a';
    script.setAttribute('data-widget-id', widgetId);

    const normalizeApiUrl = (raw) => {
      if (!raw) return '/api';
      const trimmed = String(raw).trim();
      if (!trimmed) return '/api';
      if (trimmed.startsWith('/')) return trimmed.replace(/\/$/, '');
      const clean = trimmed.replace(/\/$/, '');
      return clean.endsWith('/api') ? clean : `${clean}/api`;
    };

    const apiUrl = normalizeApiUrl(
      process.env.REACT_APP_WIDGET_API_URL ||
      process.env.REACT_APP_BACKEND_URL ||
      ''
    );
    script.setAttribute('data-api-url', apiUrl);

    document.body.appendChild(script);

    return () => {
      const existingScript = document.querySelector('script[src="/widget.js"]');
      if (existingScript) {
        document.body.removeChild(existingScript);
      }
    };
  }, []);

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        background:
          'radial-gradient(circle at top right, rgba(56,189,248,0.08), transparent 55%), #0b1628',
        color: 'white',
      }}
    >
      <img
        src="/logo-stadtki-negative.png"
        alt="StadtKI"
        style={{ height: '400px', width: 'auto', marginBottom: '1.5rem' }}
      />
      <p style={{ fontSize: '0.95rem', color: 'rgba(203,213,245,0.7)', textAlign: 'center', maxWidth: '420px' }}>
        KI-Assistent der Gemeinde Vaterstetten
      </p>
    </div>
  );
}

export default VaterstettenWidgetPage;

